module.exports = __webpack_public_path__ + "9b97e1367f00e3a184a5021c23917c1a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/owl_hoots.png
// module id = 550
// module chunks = 0